/* ZGraph
Versione 1.8.20 - 16 Aprile 2026 - Dario Scianna
                 FIX: Corretta la gestione dei dati null che adesso interrompono correttamente il grafico
Versione 1.8.19 - 15 Aprile 2026 - Dario Scianna
                 NEW: Introdotta la proprietà DrawLine per impedire che un segmento venga disegnato
Versione 1.8.18 - 14 Aprile 2026 - Alessio Verardo
                 NEW: Inserito un nuovo campo nella TSegmento che indica se un segmento è una soglia SMS
Versione 1.8.17 - 18 Marzo 2026 - Alessio Verardo
                 CHG: Adesso nella Paint() dei TZGraphHistogram é stato inserita la chiamata alla this.__DrawRighelli per fare in modo che i righelli siano disegnati al di sopra di tutto
Versione 1.8.16 - 16 Marzo 2026 - Dario Scianna
                 FIX: Adesso mostra correttamente gli hint quando il punto si trova sul bordo del grafico
Versione 1.8.15 - 10 Marzo 2026 - Francesco Ardini
                 NEW: Aggiunta proprietà DrawLine nella classe TZGraphPoint
                 NEW: Aggiunta proprietà CanHighlightSegment nella classe TPointGroup
                 CHG: Adesso la funzione per aggiungere i punti ad un gruppo ritorna il punto aggiunto 
Versione 1.7.15 - 02 Marzo 2026 - Dario Scianna
                 NEW: Introdotta la variabile ShowYLabelNotStandardFromZero per rappresentare i numeri del notch della label Y quando inizia a disegnare il notch dallo zero
                 NEW: Introdotta la variabile DrawTaccheNelTerzoAsse per disegnare le tacche nel terzo asse
                 FIX: Aggiungo un controllo sulla lunghezza del notch quando disegna la label di sisnistra
Versione 1.7.14 - 29 Gennaio 2026 - Dario Scianna
                 NEW: Aggiunta la possibilità di rappresentare tutti i numeri come positivi nella label Y anche se vanno sotto lo zero
Versione 1.7.13 - 23 Gennaio 2026 - Alessio Verardo
                 NEW: La variabile ShowLastPoint che permette di forzare la visibilità dell'ultimo numero dell'asse Y anche se non è compreso nel ciclo del notch
Versione 1.7.12 - 20 Gennaio 2026 - Alessio Verardo
                 NEW: Inserita la funzione __DrawCenterLabelX() nella TZGraph che permette di disegnare una label sull'asse X
Versione 1.7.11 - 19 Gennaio 2026 - Alessio Verardo
                 NEW: Introdotta la proprietà DelayGiornalieroMS nella TZGraph che consente di shiftare l'ora sulle label dell'asse X
Versione 1.7.10 - 14 Gennaio 2025 - Dario Scianna
                 CHG: Inserito un controllo nella HighlightMarkup che non fa apparire più i markup per i punti fuori dai margini del grafico 
Versione 1.7.9 - 17 Dicembre 2025 - Dario Scianna
                 CHG: Adesso i cerchi del grafico polare scompaiono quando superano il bordo esterno del grafico
Versione 1.7.8 - 15 Dicembre 2025 - Alessio Verardo
                 NEW: Inserita la variabile DeleteGraphOverboard  che disegna dei regttangoli ai margini del grafico per non farlo sbordare quando faccio lo zoom
Versione 1.7.7 - 05 Dicembre 2025 - Dario Scianna
                 FIX: Corretta la __DrawLeftSideLabels che metteva un valore sbagliato nel font della label laterale durante lo zoom
Versione 1.7.7 - 03 Dicembre 2025 - Dario Scianna
                 CHG: Adesso RightAxisY lascia un pò più di spazio tra il grafico e la centerlabel
Versione 1.7.7 - 21 Novembre 2025 - Dario Scianna
                 CHG: Adesso __DrawYStandardNotches inizia a disegnare dal valore minimo anzi che sempre da 0 (così gestisce anche i numeri negativi)
Versione 1.7.6 - 21 Novembre 2025 - Francesco Ardini
                 CHG: Le label adesso vengono disegnate esattamente da dove inizia a essere disegnato il grafico
Versione 1.7.5 - 31 Ottobre 2025 - Dario Scianna
                 NEW: Introdotta la proprietà ResetToZero nella TZGraphLine che interrompe la linea del grafico quando sta ripartendo a disegnare da zero
Versione 1.7.4 - 04 Settembre 2025 - Dario Scianna
                 NEW: Introdotta la possibilità di fare uno zoom prevalentemente alto nella GraphZoom con la nuova variabile ZoomTop
Versione 1.6.3 - 05 Maggio 2025 - Dario Scianna
                 CHG: Corretta la distanza a cui i numeri delle assi multiple vengono disegnati
Versione 1.6.2 - 14 Aprile 2024 - Mauro Brasile
                 NEW: Creata la HighlightHorizontalSegment 
                 CHG: Aggiunta gestione DrawMarkup per gruppo di punti
Versione 1.5.2 - 17 Febbraio 2024 - Federico Migliazzi
                 CHG: Ora le colonne del grafico si muovono con il grafico e non rimangono statici cambiando la label
Versione 1.4.2 - 26 Novembre 2024 - Francesco Ardini
                 CHG: Gestito in maniera differente il disegno dei markup per i singoli punti
Versione 1.3.2 - 18 Settembre 2024 - Francesco Ardini
                 CHG: Gestito in maniera differente il disegno dei markup
Versione 1.2.2 - 18 Settembre 2024 - Simone Biancolilla
                 CHG: Ora il datetime non va più a capo
Versione 1.1.2 - 17 Settembre 2024 - Dario Scianna
                 FIX: Risoluzione bug: aggiustato il disegno dello spessore delle linee del notch
Versione 1.1.1 - 21 Maggio 2024 - Mauro Brasile
                 FIX: Risoluzione bug: usata virgola al posto di un punto
                 FIX: Sistemata procedura __DrawYStandardNotches
                 NEW: Inserito OffsetNotch all'interno della TZGraphAxis
Versione 1.0.0 - 06 Novembre 2023 - Francesco Ardini
                 Prima versione
*/

import { TZCanvasFunct } from "./ZCanvasFunct.js"
import { TZDateFunct } from "./ZDateFunct.js"
import { TZMathFunct } from "./ZMathFunct.js"

export const TZGraphNotchType =
{
  notStandard         : 0,
  notStandardFromZero : 1,
  notPolar            : 2
}

export const TZGraphLabelType =
{
  lblInteger   : 0,
  lblDecimi    : 1,
  lblCentesimi : 2,
  lblMillesimi : 3,
  lblDate      : 4,
  lblDateTime  : 5,
  lblTime      : 6,
  lblCustom    : 7
}

export const TZTipologiaPointGroups =
{
  Histogram : 0,
}

class TZAxisLabel
{
  constructor(CaptionLeft, CaptionRight, Color)
  {
    this.Left  = CaptionLeft
    this.Right = CaptionRight
    this.Color = Color
  }
}

export class TZGraphAxis
{
  constructor()
  {  
    this.Min                  = -50
    this.Max                  = 50
    this.NotchDim             = 10
    this.Color                = "black"
    this.PenStyle             = []
    this.PenWidth             = 1
    this.NotchType            = TZGraphNotchType.notPolar  
    this.NotchPenStyle        = [5, 5]
    this.NotchPenWidth        = 1
    this.NotchColor           = '#dfdfdf'
    this.NotchFontType        = 'Calibri'
    this.NotchFontSize        = 10
    this.DrawNotchStroke      = false
    this.NotchStrokeColor     = 'black'
    this.NotchFontWeight      = 'thin'
    this.Labels               = []    
    this.Inverted             = false
    this.DrawLabelsStroke     = false
    this.LabelsStrokeColor    = 'black'
    this.FontSize             = 20
    this.FontType             = 'Calibri'
    this.FontColor            = 'black'
    this.FontWeight           = 'bold'
    this.LabelType            = TZGraphLabelType.lblDecimi
    this.DrawLabels           = true
    this.DrawNotchLabels      = true
    this.DrawUpperLabel       = false
    this.UpperLabelText       = ''
    this.UpperLabelFontColor  = 'black'
    this.UpperLabelFontWeight = 'bolder'
    this.UpperLabelFontSize   = 12
    this.Inclination          = null
    this.DistanceFromX        = null
    this.DistanceFromY        = null
    this.CustomNotchArray     = []

    this.OffsetNotch          = 0
    this.IdForMultipleAxes    = null
    this.CenterLabel          = ''
  }

  __GetLabel(Value)
  {
    let CustomNotchArray = this.CustomNotchArray;
    var ProcessLabelValueInteger = function(Caption)
    {
      if(Caption == undefined || Caption == null)
        return 0
      return parseInt(Caption)
    }

    var ProcessLabelValueDecimi = function(Caption)
    {
      if(Caption == undefined || Caption == null)
        return 0.0
      return Number.parseFloat(Caption).toFixed(1)
    }

    var ProcessLabelValueCentesimi = function(Caption)
    {
      if(Caption == undefined || Caption == null)
        return 0.00
      return Number.parseFloat(Caption).toFixed(2)
    }

    var ProcessLabelValueMillesimi = function(Caption)
    {
      if(Caption == undefined || Caption == null)
        return 0.000
      return Number.parseFloat(Caption).toFixed(3)
    }

    var ProcessLabelValueDate = function(Caption)
    {
      if(Caption == undefined || Caption == null)
        Caption = 0
      return TZDateFunct.FormatDateTime('dd/mm/yyyy', new Date(parseInt(Caption)))
    }

    var ProcessLabelValueDateTime = function(Caption)
    {
      if(Caption == undefined || Caption == null)
        Caption = 0
      return TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn ', new Date(Caption))
    }

    var ProcessLabelTime = function(Caption)
    {
      if(Caption == undefined || Caption == null)
        Caption = 0
      return TZDateFunct.FormatDateTime('hh:nn:ss', new Date(parseInt(Caption)))
    }

    var ProcessLabelCustom = function(Caption)
    {
      let ReturnValue = 0
      if (Caption != undefined && Caption != null && CustomNotchArray[Caption] != undefined)
        ReturnValue = CustomNotchArray[Caption]
      return ReturnValue
    }

    switch (this.LabelType)
    {
      case TZGraphLabelType.lblInteger        : Value = ProcessLabelValueInteger(Value); break;
      case TZGraphLabelType.lblDecimi         : Value = ProcessLabelValueDecimi(Value); break;
      case TZGraphLabelType.lblCentesimi      : Value = ProcessLabelValueCentesimi(Value); break;
      case TZGraphLabelType.lblMillesimi      : Value = ProcessLabelValueMillesimi(Value); break;
      case TZGraphLabelType.lblDate           : Value = ProcessLabelValueDate(Value); break; 
      case TZGraphLabelType.lblDateTime       : Value = ProcessLabelValueDateTime(Value); break;
      case TZGraphLabelType.lblTime           : Value = ProcessLabelTime(Value); break;
      case TZGraphLabelType.lblCustom         : Value = ProcessLabelCustom(Value);break;
    }
    return Value
  }

  AddLabel(Left,Right = '',Color = this.FontColor)
  {
    this.Labels.push(new TZAxisLabel(Left, Right, Color))
  }

  ClearLabels()
  {
    this.Labels = []
  }  
}

export class TZGraphMargins 
{
  constructor()
  {
    this.Left    = 30
    this.Right   = 25
    this.Top     = 25
    this.Bottom  = 20
    this.MinLeft   = 30
    this.MinRight  = 25
    this.MinTop    = 25
    this.MinBottom = 30 
  }
}

export class TSimplePoint
{
  constructor(X, Y)
  {
    this.X = X
    this.Y = Y
  }
}

export class TZGraphPoint
{
  constructor(x, y, Style, Color, Hint, Id, DrawMarkup, DrawLine = true)
  {
    this.X          = x
    this.Y          = y
    this.Style      = Style
    this.Color      = Color
    this.Hint       = Hint
    this.Id         = Id
    this.DrawMarkup = DrawMarkup
    this.DrawLine   = DrawLine
  }
}

export class TPointGroup
{
  constructor(Id,Color,PenWidth, Visible, AlternativeAxisY, Tipologia, DrawMarkup)
  {
    this.Id                  = Id;
    this.__Points            = []
    this.__Markup            = null
    this.__MarkupHighlighted = null
    this.__AlternativeAxisY  = AlternativeAxisY
    this.Color               = Color
    this.PenWidth            = PenWidth
    this.LastMarkup          = null
    this.Visible             = Visible
    this.MaxSpostNorth       = 0
    this.MaxSpostEast        = 0
    this.Tipologia           = Tipologia
    this.PointWidth          = null
    this.DrawMarkup          = DrawMarkup
    this.CanHighlightSegment = true
  }

  AddPoint(x, y, Hint = '', Style = [], Id = null, Color = this.Color, DrawMarkup = true, DrawLine = true)
  {
    if (Color == null)
      Color = this.Color
    let NewPoint = new TZGraphPoint(x, y, Style, Color, Hint, Id, DrawMarkup, DrawLine)
    this.__Points.push(NewPoint)
    return NewPoint
  }

  ClearPoints()
  {
    this.__Points = []
    this.MaxSpostEast = null
    this.MaxSpostNorth = null
  }
  
  SetMarkup(NewMarkup, NewMarkupHighlighted, OnSuccess = null)
  {
    if (NewMarkup != null)
    {
      this.__Markup = new Image()
      this.__MarkupHighlighted = new Image()
      this.__Markup.onload = () => {                                
                                    this.__MarkupHighlighted.src = NewMarkupHighlighted   
                                   }
      this.__MarkupHighlighted.onload = () => {
                                                if (OnSuccess != null)
                                                  OnSuccess()
                                              }
      this.__Markup.src = NewMarkup
    }
  }
}

export class TZGraph
{
  constructor(Canvas)
  {
    this.XTitleDistanceFromZero   = 30
    this.YTitleDistanceFromZero   = 30
    this.Title                    = ''
    this.TitleColor               = "red"
    this.DrawTitleStroke          = true
    this.DrawMarkup               = true
    this.ColorTitleStroke         = 'black'
    this.TitlePenStyle            = []
    this.TitleFontWeight          = 'bold'
    this.TitleFontSize            = 20
    this.TitleFontType            = 'Calibri'
    this.FontZoom                 = null
    this.__Canvas                 = Canvas
    this.__Context                = this.__Canvas.getContext('2d')
    this.AxisX                    = new TZGraphAxis()
    this.AxisY                    = new TZGraphAxis()
    this.OtherAxis                = []
    this.__Margins                = new TZGraphMargins()
    this.Background               = "white"
    this.__Markup                 = null
    this.__MarkupHighlighted      = null
    this.MarkupWidth              = 5
    this.__PointGroups            = []
    this.DrawBorders              = true
    this.OnEnterMarkup            = null    
    this.AutoScale                = false    
    this.ShowFirstMarkup          = false
    this.MultipleDrawingAxis      = false
    this.ListaRighelli            = []
    this.DeleteGraphOverboard     = false
    this.ShowYLabelNotStandardFromZero = false
    this.DrawTaccheNelTerzoAsse   = false
    
    this.VerticalLabelAxisX       = false
    this.ShowLastPoint            = false
    this.DelayGiornalieroMS       = 0
  }

  __LimitaSpostamento(Min, Max, NewMin, NewMax)
  {
    return Min > NewMax || Max < NewMin
  }

  GraphDrag(dx, dy, LimitaSpostamento = false, MinY, MaxY)
  {
    let dPxX = this.__GetKXRealUdmFromPixels() * dx * (-1)
    let dPxY = this.__GetKYRealUdmFromPixels() * dy
    let Annulla = false
    this.AxisX.Min += dPxX
    this.AxisX.Max += dPxX
    if (LimitaSpostamento)
      Annulla = this.__LimitaSpostamento(MinY, MaxY, this.AxisY.Min + dPxY, this.AxisY.Max + dPxY)
    if (!Annulla)
    {
      this.AxisY.Min += dPxY
      this.AxisY.Max += dPxY
      this.Paint()
      return true
    }
    this.Paint()
    return false
  }

  GraphZoom(NewZoom, OldZoom, LimitaSpostamento = false, MinY, MaxY, ZoomTop = false, FocusXCoord = null, FocusYCoord = null)
  {
    let dZoom = (NewZoom - OldZoom) * -1
    let Annulla = false
    let ProporzioneZoomTop    = 1
    let ProporzioneZoomBottom = 1

    if (LimitaSpostamento)
    {
      Annulla = this.__LimitaSpostamento(MinY, MaxY, this.AxisY.Min + (this.AxisY.Min * dZoom), this.AxisY.Max + (this.AxisY.Max * dZoom))
    }
    if (!Annulla)
    {
      if (FocusXCoord != null && FocusYCoord != null && !ZoomTop)
      {
        let ZoomRatio = OldZoom / NewZoom
        let FocusX = this.__GetXRealUdmFromPixels(FocusXCoord)
        let FocusY = this.__GetYRealUdmFromPixels(FocusYCoord)

        let NewAxisXMin = FocusX - (FocusX - this.AxisX.Min) * ZoomRatio
        let NewAxisXMax = FocusX + (this.AxisX.Max - FocusX) * ZoomRatio
        let NewAxisYMin = FocusY - (FocusY - this.AxisY.Min) * ZoomRatio
        let NewAxisYMax = FocusY + (this.AxisY.Max - FocusY) * ZoomRatio

        if (LimitaSpostamento)
          Annulla = this.__LimitaSpostamento(MinY, MaxY, NewAxisYMin, NewAxisYMax)

        if (!Annulla)
        {
          this.AxisX.Min = NewAxisXMin
          this.AxisX.Max = NewAxisXMax
          this.AxisY.Min = NewAxisYMin
          this.AxisY.Max = NewAxisYMax
          this.Paint()
          return true
        }
      }
      else if(ZoomTop)
      {
        ProporzioneZoomTop    = 10
        ProporzioneZoomBottom = 20
      }

      if (!Annulla)
      {
        this.AxisX.Min += this.AxisX.Min * dZoom
        this.AxisX.Max += this.AxisX.Max * dZoom
        this.AxisY.Min += this.AxisY.Min * dZoom * ProporzioneZoomBottom
        this.AxisY.Max += this.AxisY.Max * dZoom / ProporzioneZoomTop
        this.Paint()
        return true
      }
    }
    else
    {
      // let Zoom = MinY / this.AxisY.Max
      this.AxisY.Min = MaxY
      this.AxisY.Max = MinY
      // this.AxisX.Max = this.AxisX.Max * Zoom
      // this.AxisX.Min = this.AxisX.Min * Zoom      
    }
    return false
  }

  AddOtherAxis()
  {
    let ObjAxis = new TZGraphAxis()
    this.OtherAxis.push(ObjAxis)
    return ObjAxis
  }

  GetOtherAxis(Id)
  {
    for(let i = 0; i < this.OtherAxis.length; i++)
      if(this.OtherAxis[i].IdForMultipleAxes == Id)
        return this.OtherAxis[i]
    return null
  }

  RemoveOtherAxis(Id)
  {
    let RemovedAxis = null
    let index =  this.OtherAxis.findIndex((element) => {return element.IdForMultipleAxes == Id})
    if (index != -1)
    {
      RemovedAxis = this.OtherAxis[index] 
      this.OtherAxis.splice(index, 1)
    }
    return RemovedAxis
  }

  ClearOtherAxes()
  {
    this.OtherAxis = []
  }

  AddRighello()
  {
    let ObjRighello = new TRighello()
    this.ListaRighelli.push(ObjRighello)
    return ObjRighello
  }

  ClearListaRighelli()
  {
    this.ListaRighelli = []
  }

  AnnullaLastMarkup()
  {
    for (let i = 0; i < this.__PointGroups.length; i++)
    {
      let Points = this.__PointGroups[i]
      if (Points.LastMarkup != null)
      {
        // this.__DrawSingleMarkup(Points.LastMarkup, Points.__Markup, Points.__MarkupHighlighted, false)
        this.Paint(false)
        Points.LastMarkup = null
        break
      }
    }
  }

  GetCenterCoordsGraph()
  {
    return {x: this.__GetXPixelsFromRealUdm(0), y: this.__GetYPixelsFromRealUdm(0)}
  }

  __DrawSingleMarkup(SinglePoint, Markup, MarkupHighlighted, Highlighted, AxisYInUse = null)
  {
    if (MarkupHighlighted == null || MarkupHighlighted == undefined)
      MarkupHighlighted = this.__MarkupHighlighted    
    if (Markup == null || Markup == undefined)
      Markup = this.__Markup

    // this.__Context.drawImage(Highlighted ? MarkupHighlighted : Markup, 
    //                           this.__GetXPixelsFromRealUdm(SinglePoint.X) - this.MarkupWidth / 2, 
    //                           this.__GetYPixelsFromRealUdm(SinglePoint.Y) - this.MarkupWidth / 2, 
    //                           this.MarkupWidth, 
    //                           this.MarkupWidth)
    this.__Context.beginPath()
    this.__Context.fillStyle = Highlighted ? 'red' : SinglePoint.Color
    this.__Context.arc(this.__GetXPixelsFromRealUdm(SinglePoint.X),
                       this.__GetYPixelsFromRealUdm(SinglePoint.Y, AxisYInUse),
                       this.MarkupWidth / 2 - (Highlighted ? 0.5 : 0),
                       0,
                       2 * Math.PI)
    this.__Context.fill()
  }

  SetMarkup(NewMarkup, NewMarkupHighlighted, OnSuccess = null)
  {
    if (NewMarkup != null)
    {
      this.__Markup = new Image()
      this.__MarkupHighlighted = new Image()
      this.__Markup.onload = ()=> {                                
                                    this.__MarkupHighlighted.src = NewMarkupHighlighted   
                                  }
      this.__MarkupHighlighted.onload = () => {
                                                if (OnSuccess != null)
                                                  OnSuccess()
                                              }
      this.__Markup.src = NewMarkup
    }
  }

  AddGroupPoint(Id, Color, PenWidth, Visible, AlternativeAxisY = null, Tipologia = null, DrawMarkup = false)
  {
    //Id è la data
    let Group = new TPointGroup(Id, Color, PenWidth, Visible, AlternativeAxisY, Tipologia, this.DrawMarkup? true : DrawMarkup)
    this.__PointGroups.unshift(Group)
    return Group
  }

  AddGroupPointWhole(SinglePointGroup)
  {
    this.__PointGroups.push(SinglePointGroup)
  }

  ClearAllGroupPoint()
  {
    this.__PointGroups = []
  }

  GetGroupPoint(Id)
  {
    return this.__PointGroups.find(element => (element.Id == Id))
  }

  __GetFont(FontSize, FontType, FontWeight = '')
  {
    if (FontWeight != '')
      FontWeight += ' '
    if (this.FontZoom != null)
      FontSize = FontSize * this.FontZoom
    return FontWeight + FontSize + 'px ' + FontType
  }
  
  __GetKXRealUdmFromPixels()
  {
    return (this.AxisX.Max - this.AxisX.Min) / (this.__Canvas.width - this.__Margins.Right - this.__Margins.Left)
  }
  
  __GetKYRealUdmFromPixels(AxisYInUse)
  {
    if(AxisYInUse != null && AxisYInUse != undefined)
      return (AxisYInUse.Max - AxisYInUse.Min) / (this.__Canvas.height - this.__Margins.Top - this.__Margins.Bottom) 
    return (this.AxisY.Max - this.AxisY.Min) / (this.__Canvas.height - this.__Margins.Top - this.__Margins.Bottom)
  }

  __GetXRealUdmFromPixels(Pixels)
  {
    return this.__GetKXRealUdmFromPixels() * (Pixels - this.__Margins.Left)  + this.AxisX.Min
  }

  __GetYRealUdmFromPixels(Pixels)
  {
    return this.__GetKYRealUdmFromPixels() * (this.__Canvas.height - Pixels - this.__Margins.Bottom)  + this.AxisY.Min
  }
  
  __GetXPixelsFromRealUdm(RealUdm)
  {
    return (RealUdm - this.AxisX.Min) / this.__GetKXRealUdmFromPixels() + this.__Margins.Left 
  }

  __GetYPixelsFromRealUdm(RealUdm, AxisYInUse)
  {
    let AxisYMin = this.AxisY.Min
    if(AxisYInUse != null && AxisYInUse != undefined)
      AxisYMin = AxisYInUse.Min

    return this.__Canvas.height  - ((RealUdm - AxisYMin) / this.__GetKYRealUdmFromPixels(AxisYInUse)) - this.__Margins.Bottom     
  } 
  
  __CalculateMargins()
  {
    let FontSizeX = this.AxisX.FontSize
    let FontSizeY = this.AxisY.FontSize
    let NotchFontSizeX = this.AxisX.NotchFontSize
    let NotchFontSizeY = this.AxisY.NotchFontSize
    let FontSizeUpperLabel = this.AxisX.UpperLabelFontSize
    this.__Margins.Bottom = this.__Margins.MinBottom
    this.__Margins.Left = this.__Margins.MinLeft
    this.__Margins.Top = this.__Margins.MinTop
    this.__Margins.Right = this.__Margins.MinRight
    if (this.FontZoom != null)
    {
      FontSizeX = FontSizeX * this.FontZoom
      FontSizeY = FontSizeY * this.FontZoom
      NotchFontSizeX = NotchFontSizeX * this.FontZoom
      NotchFontSizeY = NotchFontSizeY * this.FontZoom
      FontSizeUpperLabel = FontSizeUpperLabel * this.FontZoom
    }
    if (this.AxisX.DrawUpperLabel)
      this.__Margins.Top += FontSizeX * 1.2
    if (this.AxisX.DrawLabels)
    {
      if(this.VerticalLabelAxisX)
      {
        if(this.AxisX.Labels.length != 0)
          this.__Margins.Bottom += this.AxisX.Labels.length * FontSizeX * 2.2
        else this.__Margins.Bottom += FontSizeX * 2.2
      }
      else this.__Margins.Bottom += this.AxisX.Labels.length * FontSizeX * 1.1
    }
    if (this.AxisY.DrawLabels)
      this.__Margins.Left += this.AxisY.Labels.length * FontSizeY * 1.1 - FontSizeY * 0.4
    if (this.AxisX.DrawNotchLabels && this.AxisX.NotchType != TZGraphNotchType.notPolar)
      this.__Margins.Bottom += NotchFontSizeX * 1.1    
    if (this.AxisY.DrawNotchLabels && this.AxisY.NotchType != TZGraphNotchType.notPolar)
    {
      if(this.OtherAxis.length == 1)
        this.__Margins.Left += NotchFontSizeY * 1.4
      else 
        this.__Margins.Left += NotchFontSizeY * 1.1
    }
      
    let XAxisWidth = this.__Canvas.width - this.__Margins.Left - this.__Margins.Right
    let YAxisWidth = this.__Canvas.height - this.__Margins.Top - this.__Margins.Bottom
    if (this.AxisX.NotchType == TZGraphNotchType.notPolar)
    {
      if (XAxisWidth > YAxisWidth)
      {
        let Difference = XAxisWidth - YAxisWidth
        this.__Margins.Left += Difference / 2
        this.__Margins.Right += Difference / 2         
      }
      if (XAxisWidth < YAxisWidth)
      {
        let Difference = YAxisWidth - XAxisWidth
        this.__Margins.Top += Difference / 2 
        this.__Margins.Bottom += Difference / 2  
      }      
    }

    if(this.OtherAxis.length == 1 && !this.MultipleDrawingAxis)
      this.__Margins.Right = this.__Margins.Left
    if(this.MultipleDrawingAxis)
    {
      let Self = this
      this.OtherAxis.forEach(function()
      {
        Self.__Margins.Right += Self.__Margins.Left
      })
    }
  }

  __DrawXNotches(MinY, MaxY)
  {
    this.__Context.strokeStyle = this.AxisX.NotchColor
    this.__Context.setLineDash(this.AxisX.NotchPenStyle)
    this.__Context.lineWidth = this.AxisX.NotchPenWidth 
    this.__Context.beginPath()
    switch (this.AxisX.NotchType)
    {
      case TZGraphNotchType.notStandard         : this.__DrawXStandardNotches(MinY, MaxY); break;
      case TZGraphNotchType.notStandardFromZero : this.__DrawXStdFromZeroNotches(MinY, MaxY); break;
      case TZGraphNotchType.notPolar            : this.__DrawXPolarNotches(); break;
    }
    this.__Context.stroke()
  }

  __DrawYNotches(MinX, MaxX)
  {
    this.__Context.setLineDash(this.AxisY.NotchPenStyle)    
    this.__Context.lineWidth = this.AxisY.NotchPenWidth 
    this.__Context.beginPath()
    switch (this.AxisY.NotchType)
    {
      case TZGraphNotchType.notStandard         : this.__DrawYStandardNotches(MinX, MaxX); break;
      case TZGraphNotchType.notStandardFromZero : this.__DrawYStdFromZeroNotches(MinX, MaxX); break;
    }
    this.__Context.stroke()
  }

  __DrawYRightNotches(AlternativeAxisY)
  {
    this.__Context.strokeStyle = AlternativeAxisY.NotchColor
    this.__Context.setLineDash(AlternativeAxisY.NotchPenStyle)    
    this.__Context.lineWidth = AlternativeAxisY.NotchPenWidth 
    this.__Context.beginPath()
    switch (AlternativeAxisY.NotchType)
    {
      case TZGraphNotchType.notStandard         : this.__DrawYRightStandardNotches(AlternativeAxisY); break;
    }
    this.__Context.stroke()
  }

  __DrawYRightNotchesMultipleAxes(MultipleAxis, i)
  {
    this.__Context.strokeStyle = MultipleAxis.NotchColor
    this.__Context.setLineDash(MultipleAxis.NotchPenStyle)    
    this.__Context.lineWidth = MultipleAxis.NotchPenWidth 
    this.__Context.beginPath()
    switch (MultipleAxis.NotchType)
    {
      case TZGraphNotchType.notStandard : this.__DrawYRightStandardNotchesMultipleAxes(MultipleAxis, i); break;
    }
    this.__Context.stroke()
  }

  __DrawXStdFromZeroNotches(MinY, MaxY)
  {
    let CurrentNotch = 0 + this.AxisX.OffsetNotch
    // if (this.AxisX.Min >= 0)
    //   CurrentNotch = this.AxisX.Min + this.AxisX.OffsetNotch
    // else
    // {
      while (this.AxisX.Min <= CurrentNotch)
      {
        if (CurrentNotch <= this.AxisX.Max)
        {
          let StartPx = this.__GetXPixelsFromRealUdm(CurrentNotch)        
          this.__DrawXAxisLabel(CurrentNotch)
          this.__Context.moveTo(StartPx, MinY)
          this.__Context.lineTo(StartPx, MaxY)
        }
        CurrentNotch -= this.AxisX.NotchDim
      }
      CurrentNotch = this.AxisX.NotchDim
    // }
    while (this.AxisX.Max >= CurrentNotch)
    {
      if(CurrentNotch >= this.AxisX.Min)
      {
        this.__DrawXAxisLabel(CurrentNotch)
        let StartPx = this.__GetXPixelsFromRealUdm(CurrentNotch)
        this.__Context.moveTo(StartPx, MinY)
        this.__Context.lineTo(StartPx, MaxY)
      }
      CurrentNotch += this.AxisX.NotchDim
    }
  }

  __DrawXStandardNotches(MinY, MaxY)
  {
    let CurrentNotch = this.AxisX.Min + this.AxisX.OffsetNotch + this.DelayGiornalieroMS
    // this.__DrawXAxisLabel(0)
    while (this.AxisX.Max >= CurrentNotch)
    {
      this.__DrawXAxisLabel(CurrentNotch)
      
      // if (CurrentNotch != 0)
      // {
      let StartPx = this.__GetXPixelsFromRealUdm(CurrentNotch)
      this.__Context.moveTo(StartPx, MinY)
      this.__Context.lineTo(StartPx, MaxY)
      // }

      CurrentNotch += this.AxisX.NotchDim
    }
  }

  __DrawXPolarNotches()
  {
    let ZeroX = this.__GetXPixelsFromRealUdm(0)
    let ZeroY = this.__GetYPixelsFromRealUdm(0)
    let MaxMeasure = this.AxisX.Min * -1 < this.AxisX.Max ? this.AxisX.Max : this.AxisX.Min * -1
    let MaxY = this.AxisY.Min * -1 < this.AxisY.Max ? this.AxisY.Max : this.AxisY.Min * -1
    if (MaxY > MaxMeasure)
      MaxMeasure = MaxY
    let CurrentNotch = this.AxisX.NotchDim
    this.__DrawPolarAxisLabel(0)
    this.__DrawAlternativePolarAxisLabel(0)
    while (MaxMeasure >= CurrentNotch)
    {
      let Radius = this.__GetXPixelsFromRealUdm(CurrentNotch) - ZeroX
      if(ZeroX - Radius + 0.00001 >= this.__Margins.Left && ZeroY - Radius + 0.00001 >= this.__Margins.Top)
      {
        this.__DrawPolarAxisLabel(CurrentNotch)
        this.__DrawPolarAxisLabel(CurrentNotch * -1)
        this.__DrawAlternativePolarAxisLabel(CurrentNotch)
        if (Radius > 0)
          this.__Context.arc(ZeroX, ZeroY, Radius, 0, 2 * Math.PI);
      }
      CurrentNotch += this.AxisX.NotchDim
    }
  }

  __DrawYStdFromZeroNotches(MinX, MaxX)
  {
    let CurrentNotch = 0
    if (this.AxisY.Min >= 0)
      CurrentNotch = this.AxisY.Min
    else
    {
      if(this.ShowYLabelNotStandardFromZero)
        this.__DrawYAxisLabel(CurrentNotch)
      CurrentNotch = 0 - this.AxisY.NotchDim
      while (this.AxisY.Min <= CurrentNotch)
      {
        let StartPx = this.__GetYPixelsFromRealUdm(CurrentNotch)
        this.__Context.moveTo(MinX, StartPx)
        this.__Context.lineTo(MaxX, StartPx)
        if(this.ShowYLabelNotStandardFromZero)
          this.__DrawYAxisLabel(CurrentNotch)
        CurrentNotch -= this.AxisY.NotchDim
      }
      CurrentNotch = this.AxisY.NotchDim
    }
    while (this.AxisY.Max >= CurrentNotch)
    {
      let StartPx = this.__GetYPixelsFromRealUdm(CurrentNotch)
      this.__Context.moveTo(MinX, StartPx)
      this.__Context.lineTo(MaxX, StartPx)
      if(this.ShowYLabelNotStandardFromZero)
        this.__DrawYAxisLabel(CurrentNotch)
      CurrentNotch += this.AxisY.NotchDim
    }
  }

  __DrawYStandardNotches(MinX, MaxX)
  {
    let CurrentNotch = 0
    
    let Min = this.AxisY.Min
    let Max = this.AxisY.Max

    if (this.AxisY.Inverted)
    {
      Min = this.AxisY.Max
      Max = this.AxisY.Min
    }
    
    if (!this.AxisY.Inverted)
    {
      CurrentNotch = this.AxisY.Min + this.AxisY.OffsetNotch
      while (this.AxisY.Max >= CurrentNotch)
      {        
        // if (CurrentNotch != 0)
        // {
          let StartPx = this.__GetYPixelsFromRealUdm(CurrentNotch)
          this.__Context.moveTo(MinX, StartPx)
          this.__Context.lineTo(MaxX, StartPx)
        // }      
        
        this.__DrawYAxisLabel(CurrentNotch)
        CurrentNotch += this.AxisY.NotchDim
        CurrentNotch = parseFloat(CurrentNotch.toFixed(5))
      }

      // if ((this.AxisY.Max % this.AxisY.NotchDim) !== 0) 
      // {
      //   let StartPx = this.__GetYPixelsFromRealUdm(this.AxisY.Max)
      //   this.__Context.moveTo(MinX, StartPx)
      //   this.__Context.lineTo(MaxX, StartPx)
      //   this.__DrawYAxisLabel(this.AxisY.Max)
      // }
    }
    else
    {
      while (Min <= Max)
      {
        let StartPx = this.__GetYPixelsFromRealUdm(Min)
        if( StartPx >= this.__Margins.Top-1)
          this.__DrawYAxisLabel(Min)
        if( StartPx >= this.__Margins.Top)
        {
          this.__DrawYAxisLabel(Min)
          this.__Context.moveTo(MinX, StartPx)
          this.__Context.lineTo(MaxX, StartPx)
        }
        Min += this.AxisY.NotchDim
      }

      if (this.ShowLastPoint && ((Max) % this.AxisY.NotchDim) != 0) 
      {
        this.__DrawYAxisLabel(Max)
      }
    }
  }

  __DrawYRightStandardNotches(AlternativeAxisY)
  {
    let CurrentNotch = 0
    if (!AlternativeAxisY.Inverted)
    {
      if(!this.DrawTaccheNelTerzoAsse)
      {
        CurrentNotch = AlternativeAxisY.Min + AlternativeAxisY.OffsetNotch
        while (AlternativeAxisY.Max >= CurrentNotch + AlternativeAxisY.NotchDim)
        {        
          if (CurrentNotch != 0)
          {
            this.__Context.strokeStyle = AlternativeAxisY.LabelsStrokeColor
            let StartPx = this.__GetYPixelsFromRealUdm(CurrentNotch, AlternativeAxisY)
            this.__Context.moveTo(this.AxisX.Max - 10, StartPx)
            this.__Context.lineTo(this.AxisX.Max, StartPx)
          }      
          this.__DrawYRightAxisLabel(CurrentNotch, AlternativeAxisY)
          CurrentNotch += AlternativeAxisY.NotchDim
        }
      }
      else
      {
        CurrentNotch = AlternativeAxisY.Min + AlternativeAxisY.OffsetNotch + AlternativeAxisY.NotchDim
        while (AlternativeAxisY.Max >= CurrentNotch + AlternativeAxisY.NotchDim)
        {        
          this.__Context.strokeStyle = AlternativeAxisY.LabelsStrokeColor
          let StartPx = this.__GetYPixelsFromRealUdm(CurrentNotch, AlternativeAxisY)
          this.__Context.moveTo(this.__GetXPixelsFromRealUdm(this.AxisX.Max) - 3, StartPx)
          this.__Context.lineTo(this.__GetXPixelsFromRealUdm(this.AxisX.Max) + 3, StartPx)
          this.__DrawYRightAxisLabel(CurrentNotch, AlternativeAxisY)
          CurrentNotch += AlternativeAxisY.NotchDim
        }

      }
    }
  }

  __DrawYRightStandardNotchesMultipleAxes(MultipleAxis, i)
  {
    let CurrentNotch = 0
    if (!MultipleAxis.Inverted)
    {
      CurrentNotch = MultipleAxis.Min + MultipleAxis.OffsetNotch 
      while (MultipleAxis.Max >= CurrentNotch + MultipleAxis.NotchDim)
      {        
        if (CurrentNotch != 0)
        {
          let StartPx = this.__GetYPixelsFromRealUdm(CurrentNotch, MultipleAxis)
          this.__Context.moveTo(this.AxisX.Max + 10 * i, StartPx)
          this.__Context.lineTo(this.AxisX.Max, StartPx)
        }      
        
        this.__DrawYMultipleAxesLabel(CurrentNotch, MultipleAxis, i)
        CurrentNotch += MultipleAxis.NotchDim
      }
    }
  }

  __DrawLeftSideLabels()
  {
    let FontSize = this.AxisY.FontSize
    let NotchFontSize = this.AxisY.NotchFontSize
    
    if (this.FontZoom != null)
    {
      FontSize = FontSize * this.FontZoom
      NotchFontSize = NotchFontSize * this.FontZoom
    }
    
    let YCoordBottom = this.__GetYPixelsFromRealUdm(this.AxisY.Min)
    let YCoordTop = this.__Margins.Top + 10
    let LunghezzaNotch = this.__Context.measureText(this.AxisY.NotchDim).width
    let XCoord = this.__GetXPixelsFromRealUdm(this.AxisX.Min) + FontSize * 0.6 - ( this.RightAxisY != null ? 10 : 2)
    if(LunghezzaNotch > 20)
    {
      XCoord = this.__GetXPixelsFromRealUdm(this.AxisX.Min) - (LunghezzaNotch - 18)
    }
    
    if (this.AxisY.DrawNotchLabels && this.AxisY.NotchType != TZGraphNotchType.notPolar)
      XCoord -= NotchFontSize * 1.1 + 5
    this.__Context.font = this.__GetFont(this.AxisY.FontSize, this.AxisY.FontType, this.AxisY.FontWeight)
    this.__Context.strokeStyle = this.AxisY.LabelsStrokeColor
    
    for (let i = 0; i < this.AxisY.Labels.length; i++)
    {
      let Label = this.AxisY.Labels[i]
      this.__Context.fillStyle = Label.Color
      XCoord -= FontSize * 1.1
      this.__Context.textAlign = 'right' 
      TZCanvasFunct.WriteVerticalString(this.__Context, XCoord, YCoordTop, Label.Left, this.AxisY.DrawLabelsStroke)
      this.__Context.textAlign = 'left' 
      TZCanvasFunct.WriteVerticalString(this.__Context, XCoord, YCoordBottom, Label.Right, this.AxisY.DrawLabelsStroke)
    }    
  }

  __DrawRightSideLabels(AlternativeAxisY)
  {
    let FontSize = AlternativeAxisY.FontSize
    let NotchFontSize = AlternativeAxisY.NotchFontSize
    if (this.FontZoom != null)
    {
      FontSize = FontSize * this.FontZoom
      NotchFontSize = NotchFontSize * this.FontZoom
    }
    let YCoordBottom = this.__GetYPixelsFromRealUdm(this.AxisY.Min) - 10
    let YCoordTop    = this.__Margins.Top + 10
    let XCoord       = this.__GetXPixelsFromRealUdm(this.AxisX.Max) + FontSize * 0.6
    
    if (AlternativeAxisY.DrawNotchLabels && AlternativeAxisY.NotchType != TZGraphNotchType.notPolar)
      XCoord += NotchFontSize * 1.1
    
    this.__Context.font        = this.__GetFont(FontSize, AlternativeAxisY.FontType, AlternativeAxisY.FontWeight)    
    this.__Context.strokeStyle = AlternativeAxisY.LabelsStrokeColor

    for (let i = 0; i < AlternativeAxisY.Labels.length; i++)
    {
      let Label = AlternativeAxisY.Labels[i]
      this.__Context.fillStyle = Label.Color
      XCoord += FontSize * 1.1
      this.__Context.textAlign = 'right' 
      TZCanvasFunct.WriteVerticalString(this.__Context, XCoord, YCoordTop, Label.Right, AlternativeAxisY.DrawLabelsStroke, true)
      this.__Context.textAlign = 'left'
      TZCanvasFunct.WriteVerticalString(this.__Context, XCoord, YCoordBottom, Label.Left, AlternativeAxisY.DrawLabelsStroke, true)
    }    
  }

  __DrawYRightSideLabelsMultipleAxes(MultipleAxis, i)
  {
    let FontSize      = MultipleAxis.FontSize
    let NotchFontSize = MultipleAxis.NotchFontSize

    if (this.FontZoom != null)
    {
      FontSize      = FontSize * this.FontZoom
      NotchFontSize = NotchFontSize * this.FontZoom
    }
    let YCoordBottom = this.__GetYPixelsFromRealUdm(this.AxisY.Min)
    let YCoordTop    = this.__Margins.Top 
    let XCoord       = this.__GetXPixelsFromRealUdm(this.AxisX.Max) + FontSize * 0.6 + 15 + 65 * i
    
    if (MultipleAxis.DrawNotchLabels && MultipleAxis.NotchType != TZGraphNotchType.notPolar)
      XCoord += NotchFontSize * 1.1
    
    this.__Context.font        = this.__GetFont(FontSize, MultipleAxis.FontType, MultipleAxis.FontWeight)    
    this.__Context.strokeStyle = MultipleAxis.LabelsStrokeColor

    for (let i = 0; i < MultipleAxis.Labels.length; i++)
    {
      let Label = MultipleAxis.Labels[i]
      this.__Context.fillStyle = Label.Color
      XCoord += FontSize * 1.1
      this.__Context.textAlign = 'right' 
      TZCanvasFunct.WriteVerticalString(this.__Context, XCoord, YCoordTop, Label.Right, MultipleAxis.DrawLabelsStroke, true)
      this.__Context.textAlign = 'left'
      TZCanvasFunct.WriteVerticalString(this.__Context, XCoord, YCoordBottom, Label.Left, MultipleAxis.DrawLabelsStroke, true)
    } 
  }

  __DrawYLinesRightAxes(MultipleAxis, i)
  {
    let FontSize      = MultipleAxis.FontSize

    let YCoordBottom = this.__GetYPixelsFromRealUdm(this.AxisY.Min)
    let YCoordTop    = this.__Margins.Top 
    let XCoord       = this.__GetXPixelsFromRealUdm(this.AxisX.Max) + FontSize * 0.6 + 5 + 65 * i

    this.__Context.beginPath()
    this.__Context.lineWidth   = 1
    this.__Context.strokeStyle = MultipleAxis.Color != null? MultipleAxis.Color : 'black'
    this.__Context.setLineDash([])

    this.__Context.moveTo(XCoord, YCoordBottom)
    this.__Context.lineTo(XCoord, YCoordTop)    
    this.__Context.stroke()
  }

  __DrawBottomSideLabels()
  {    
    let FontSize = this.AxisX.FontSize
    let NotchFontSize = this.AxisX.NotchFontSize
    if (this.FontZoom != null)
    {
      FontSize = FontSize * this.FontZoom
      NotchFontSize = NotchFontSize * this.FontZoom
    }
    let XCoordLeft = this.__Margins.Left
    let XCoordRight = this.__GetXPixelsFromRealUdm(this.AxisX.Max) - 10
    let YCoord = this.__GetYPixelsFromRealUdm(this.AxisY.Min)
    if (this.AxisX.DrawNotchLabels && this.AxisX.NotchType != TZGraphNotchType.notPolar)
      YCoord += NotchFontSize * 1.1 + 5
    this.__Context.font = this.__GetFont(this.AxisX.FontSize, this.AxisX.FontType, this.AxisX.FontWeight)
    this.__Context.strokeStyle = this.AxisX.LabelsStrokeColor
    for (let i = 0; i < this.AxisX.Labels.length; i++)
    {
      YCoord += FontSize * 1.1
      let Label = this.AxisX.Labels[i]
      this.__Context.fillStyle = Label.Color

      this.__Context.textAlign = 'left'
      if (this.AxisX.DrawLabelsStroke)
         this.__Context.strokeText(Label.Left, XCoordLeft, YCoord)
      this.__Context.fillText(Label.Left, XCoordLeft, YCoord)

      this.__Context.textAlign = 'right'
      if (this.AxisX.DrawLabelsStroke)
         this.__Context.strokeText(Label.Right, XCoordRight, YCoord)
      this.__Context.fillText(Label.Right, XCoordRight, YCoord)
    }    
  }

  __DrawYAxis(MinY, MaxY)
  {    
    // let ZeroX = this.__GetXPixelsFromRealUdm(0 + (this.RightAxisY != null? this.__Margins.Left : 0))
    let ZeroX = this.__GetXPixelsFromRealUdm(0)
    this.__Context.beginPath()
    this.__Context.lineWidth = this.AxisY.PenWidth
    this.__Context.setLineDash(this.AxisY.PenStyle)
    this.__Context.moveTo(ZeroX, MinY)
    this.__Context.lineTo(ZeroX, MaxY)
    this.__Context.stroke()
  }

  __DrawXAxis(MinX, MaxX)
  {  
    let ZeroY = this.__GetYPixelsFromRealUdm(0)
    this.__Context.beginPath()
    this.__Context.lineWidth = this.AxisX.PenWidth
    this.__Context.strokeStyle = this.AxisX.Color
    this.__Context.setLineDash(this.AxisX.PenStyle)
    this.__Context.moveTo(MinX, ZeroY)
    this.__Context.lineTo(MaxX, ZeroY)    
    this.__Context.stroke()
  }

  __DrawOtherAxisPolar()
  {
    // attualmente funzionante solo per polare
    for (let i = 0; i < this.OtherAxis.length; i++)
    {
      let Axis = this.OtherAxis[i]
      let Radius = (this.AxisX.Max - this.AxisX.Min) / 2
      let CoordX = Radius * Math.cos(TZMathFunct.DegToRad(Axis.Inclination))
      let CoordY = Radius * Math.sin(TZMathFunct.DegToRad(Axis.Inclination))
      let MinX = this.__GetXPixelsFromRealUdm(CoordX * (-1))
      let MinY = this.__GetYPixelsFromRealUdm(CoordY * (-1))      
      let MaxX = this.__GetXPixelsFromRealUdm(CoordX)      
      let MaxY = this.__GetYPixelsFromRealUdm(CoordY)
      this.__Context.beginPath()
      this.__Context.lineWidth = Axis.PenWidth
      this.__Context.strokeStyle = Axis.Color
      this.__Context.setLineDash(Axis.PenStyle)
      // si dovrebbe poter adattare per gli assi non passanti per il centro sottraendo o sommando alle coordinate Min e Max
      this.__Context.moveTo(MinX, MinY)
      this.__Context.lineTo(MaxX, MaxY)    
      this.__Context.stroke()
    }
  }
  
  __DrawOtherAxis()
  {
    for (let i = 0; i < this.OtherAxis.length; i++)
    {
      let Axis = this.OtherAxis[i]
      if (Axis.DistanceFromX == null)
        Axis.DistanceFromX = 0
      if (Axis.DistanceFromY == null)
        Axis.DistanceFromY = 0
      let ZeroY  = Axis.DistanceFromX
      let ZeroX  = Axis.DistanceFromY
      let Radius = this.AxisX.Max - ZeroX
      let CoordX = ZeroX + Radius * Math.cos(TZMathFunct.DegToRad(Axis.Inclination))
      let CoordY = ZeroY + Radius * Math.sin(TZMathFunct.DegToRad(Axis.Inclination))      

      // let MinX = this.__GetXPixelsFromRealUdm(ZeroX - CoordX)
      // let MinY = this.__GetYPixelsFromRealUdm(ZeroY - CoordY)      
      // let MaxX = this.__GetXPixelsFromRealUdm((CoordX + ZeroX))      
      // let MaxY = this.__GetYPixelsFromRealUdm((CoordY + ZeroY))

      if (CoordY > this.AxisY.Max)
        CoordY = this.AxisY.Max

      let MinX = this.__GetXPixelsFromRealUdm(ZeroX)
      let MinY = this.__GetYPixelsFromRealUdm(ZeroY)
      let MaxX = this.__GetXPixelsFromRealUdm((CoordX))      
      let MaxY = this.__GetYPixelsFromRealUdm((CoordY))
      
      // MinX = this.__GetXPixelsFromRealUdm(this.AxisX.Min)
      // MaxX = this.__GetXPixelsFromRealUdm(this.AxisX.Max)
      // if ((MinY < this.__GetYPixelsFromRealUdm(this.AxisY.Min) &&
      //     MaxY > this.__GetYPixelsFromRealUdm(this.AxisY.Max)))
      // {
      this.__Context.beginPath()
      this.__Context.lineWidth = Axis.PenWidth
      this.__Context.strokeStyle = Axis.Color
      this.__Context.setLineDash(Axis.PenStyle)
      // si dovrebbe poter adattare per gli assi non passanti per il centro sottraendo o sommando alle coordinate Min e Max
      this.__Context.moveTo(MinX, MinY)
      this.__Context.lineTo(MaxX, MaxY)    
      this.__Context.stroke()
      // }
    }
  }

  __DrawPolarAxisLabel(Notch)
  {
    if (this.AxisX.DrawNotchLabels)
    {
      let Value = this.AxisX.__GetLabel(Notch)
      let YCoord = this.__GetYPixelsFromRealUdm(0) - 5
      let XCoord = this.__GetXPixelsFromRealUdm(Notch)
      this.__Context.font = this.__GetFont(this.AxisX.NotchFontSize, this.AxisX.NotchFontType, this.NotchFontWeight)
      this.__Context.fillStyle = this.AxisX.FontColor
      this.__Context.textAlign = 'left' 
      this.__Context.fillText(Value, XCoord, YCoord)
    }
  }

  __DrawXAxisLabel(Notch)
  {
    if (this.AxisX.DrawNotchLabels)
    {
      let Value = this.AxisX.__GetLabel(Notch)
      let YCoord = this.__GetYPixelsFromRealUdm(this.AxisY.Min) + 12
      let XCoord = this.__GetXPixelsFromRealUdm(Notch)
      this.__Context.font = this.__GetFont(this.AxisX.NotchFontSize, this.AxisX.NotchFontType, this.NotchFontWeight)
      this.__Context.fillStyle = this.AxisX.FontColor
      this.__Context.textAlign = 'center' 

      if(this.VerticalLabelAxisX)
      {
        if(this.AxisX.LabelType == TZGraphLabelType.lblDateTime ||
           this.AxisX.LabelType == TZGraphLabelType.lblDate)
        {
          //Value = Value.split("$");
          TZCanvasFunct.WriteVerticalString(this.__Context, XCoord + 10, YCoord + 45, Value)
          // if (this.AxisX.LabelType == TZGraphLabelType.lblDateTime)
          //   TZCanvasFunct.WriteVerticalString(this.__Context, XCoord + 15, YCoord + 30, Value[1])
        }
        else TZCanvasFunct.WriteVerticalString(this.__Context, XCoord, YCoord + 10, Value)
      }
      else this.__Context.fillText(Value, XCoord, YCoord)
    }
  }

  __DrawYAxisLabel(Notch, OnlyPositiveNumber = false)
  {
    if (this.AxisY.DrawNotchLabels)
    {
      let Value = this.AxisY.__GetLabel(Notch)
      if(OnlyPositiveNumber)
        Value = Math.abs(Value)
      let YCoord = this.__GetYPixelsFromRealUdm(Notch)
      let XCoord = this.__GetXPixelsFromRealUdm(this.AxisX.Min) - 5
      this.__Context.font = this.__GetFont(this.AxisY.NotchFontSize, this.AxisY.NotchFontType, this.NotchFontWeight)
      this.__Context.fillStyle = this.AxisY.FontColor
      this.__Context.textAlign = 'right' 
      this.__Context.fillText(Value, XCoord, YCoord)
    }
  }

  __DrawYRightAxisLabel(Notch, AlternativeAxisY)
  {
    if (AlternativeAxisY.DrawNotchLabels)
    {
      let Value = AlternativeAxisY.__GetLabel(Notch)
      let YCoord = this.__GetYPixelsFromRealUdm(Notch, AlternativeAxisY)
      let XCoord = this.__GetXPixelsFromRealUdm(this.AxisX.Max) + 25
      this.__Context.font = this.__GetFont(AlternativeAxisY.NotchFontSize, AlternativeAxisY.NotchFontType, this.NotchFontWeight)
      this.__Context.fillStyle = AlternativeAxisY.FontColor
      this.__Context.textAlign = 'right' 
      this.__Context.fillText(Value, XCoord, YCoord)
    }
  }

  __DrawYMultipleAxesLabel(Notch, MultipleAxis, i)
  {
    if (MultipleAxis.DrawNotchLabels)
    {
      let Value = MultipleAxis.__GetLabel(Notch)
      this.__Context.font = this.__GetFont(MultipleAxis.NotchFontSize, MultipleAxis.NotchFontType, this.NotchFontWeight)
      let LunghezzaValue = this.__Context.measureText(Value).width
      let YCoord = this.__GetYPixelsFromRealUdm(Notch, MultipleAxis)
      let XCoord = this.__GetXPixelsFromRealUdm(this.AxisX.Max) + 20 + 65 * i + LunghezzaValue
      this.__Context.fillStyle = MultipleAxis.FontColor
      this.__Context.textAlign = 'right' 
      this.__Context.fillText(Value, XCoord, YCoord)
    }
  }

  __DrawAlternativePolarAxisLabel(Notch)
  {
    if (this.AxisY.DrawNotchLabels)
    {
      let Value = this.AxisY.__GetLabel(Notch)
      let YCoord = this.__GetYPixelsFromRealUdm(Notch) - 5
      let XCoord = this.__GetXPixelsFromRealUdm(0) - 2
      this.__Context.font = this.__GetFont(this.AxisY.NotchFontSize, this.AxisY.NotchFontType, this.NotchFontWeight)
      this.__Context.fillStyle = this.AxisY.FontColor
      this.__Context.textAlign = 'right' 
      this.__Context.fillText(Value, XCoord, YCoord)
    }
  }

  __DrawUpperLabel()
  {
    let Value = this.AxisX.UpperLabelText
    let YCoord = this.__GetYPixelsFromRealUdm(this.AxisY.Max) - (this.__Margins.Top / 2)
    let XCoord = this.__GetXPixelsFromRealUdm((this.AxisX.Min + this.AxisX.Max) / 2)
    this.__Context.font = this.__GetFont(this.AxisX.UpperLabelFontSize, this.AxisX.FontType, this.AxisX.UpperLabelFontWeight)
    this.__Context.fillStyle = this.AxisX.UpperLabelFontColor
    this.__Context.textAlign = 'center' 
    this.__Context.fillText(Value, XCoord, YCoord)
  }

  __DrawCenterLabel()
  {
    let FontSize = this.AxisY.FontSize
    let NotchFontSize = this.AxisY.NotchFontSize
    
    if (this.FontZoom != null)
    {
      FontSize = FontSize * this.FontZoom
      NotchFontSize = NotchFontSize * this.FontZoom
    }
    
    let XCoord = this.__GetXPixelsFromRealUdm(this.AxisX.Min) + FontSize * 0.6 - ( this.RightAxisY != null? 20 : 10)
    let LarghezzaTesto = this.__Context.measureText(this.AxisY.CenterLabel).width;
    
    if (this.AxisY.DrawNotchLabels && this.AxisY.NotchType != TZGraphNotchType.notPolar)
      XCoord -= NotchFontSize * 1.1 + 5

    this.__Context.font = this.__GetFont(FontSize, this.AxisY.FontType, this.AxisY.FontWeight)
    this.__Context.strokeStyle = this.AxisY.LabelsStrokeColor
    let AltezzaGrafico = this.__Canvas.height - this.__Margins.Top - this.__Margins.Bottom
    let Margine = (AltezzaGrafico - LarghezzaTesto) / 2
    let YCoord = this.__Margins.Top + Margine

    TZCanvasFunct.WriteVerticalString(this.__Context, XCoord - 20, YCoord, this.AxisY.CenterLabel)

    if(this.TerzoAsse != null)
      TZCanvasFunct.WriteVerticalString(this.__Context, this.__Canvas.width - 20, YCoord, this.TerzoAsse.CenterLabel)
  }

  __DrawCenterLabelX()
  {
    let FontSize = this.AxisY.FontSize
    let NotchFontSize = this.AxisX.NotchFontSize
    
    if (this.FontZoom != null)
    {
      FontSize = FontSize * this.FontZoom
      NotchFontSize = NotchFontSize * this.FontZoom
    }
    
    this.__Context.font = this.__GetFont(FontSize, this.AxisX.FontType, this.AxisX.FontWeight)
    this.__Context.fillStyle = this.AxisX.LabelsStrokeColor
    this.__Context.textAlign = 'right'

    let XCoord = this.__GetXPixelsFromRealUdm(this.AxisX.Max)

    let DistanzaMax = this.__Context.measureText(this.AxisX.Max).width
    let AltezzaLabel = this.__Context.measureText(this.AxisX.CenterLabel).actualBoundingBoxAscent + this.__Context.measureText(this.AxisX.CenterLabel).actualBoundingBoxDescent

    let YCoord = this.__Canvas.height - this.__Margins.Bottom + DistanzaMax + AltezzaLabel + 10
    this.__Context.fillText(this.AxisX.CenterLabel, XCoord, YCoord)
  }
  
  // __DrawPolarGraphTitle()
  // {
  //   let XCoord = this.__GetXPixelsFromRealUdm(0) + this.XTitleDistanceFromZero
  //   let YCoord = this.__GetYPixelsFromRealUdm(0) - this.YTitleDistanceFromZero
  //   this.__Context.beginPath() 
  //   this.__Context.font = this.__GetFont(this.TitleFontSize, this.TitleFontType, this.TitleFontWeight)
  //   this.__Context.fillStyle = this.TitleColor
  //   this.__Context.textAlign = 'left'
  //   if (this.DrawTitleStroke)
  //   {
  //     this.__Context.lineWidth = 2
  //     this.__Context.setLineDash([])
  //     this.__Context.strokeStyle = this.ColorTitleStroke
  //     this.__Context.strokeText(this.Title, XCoord, YCoord)
  //   }
  //   this.__Context.fillText(this.Title, XCoord, YCoord)
  // }

  // __DrawGraphTitle()
  // {
  //   return
  // }
  
  MouseMove(X,Y)
  {
    if(this.OnPointHighlighted != null)
      this.OnPointHighlighted( X,Y,Punto)
  }

  HighlightSegment(XCoord, YCoord)
  {
    let LastMarkup = null
    for (let i = 0; i < this.__PointGroups.length; i++)
    {
      let Points = this.__PointGroups[i]
      let PreviousPoint = Points.__Points[0]      
      for (let j = 0; j < Points.__Points.length; j++)
      {
        let SinglePoint = Points.__Points[j]
        let YPrevious = this.__GetYPixelsFromRealUdm(PreviousPoint.Y)
        let XPoint = this.__GetXPixelsFromRealUdm(SinglePoint.X)
        let YPoint = this.__GetYPixelsFromRealUdm(SinglePoint.Y)

        if (SinglePoint.Id == PreviousPoint.Id &&
            (XPoint <= XCoord + 1 && 
             XPoint >= XCoord - 1) && 
             YCoord <= YPrevious && 
             YCoord >= YPoint)
        {
          LastMarkup = {}
          LastMarkup.Hint = SinglePoint.Hint
          LastMarkup.Coords = {}
          LastMarkup.Coords.X = XPoint
          LastMarkup.Coords.Y = YPoint 
          break
        }
        PreviousPoint = SinglePoint
      }
    }
    return LastMarkup
  }

  HighlightHorizontalSegment(XCoord, YCoord)
  {
    let LastMarkup = null
    for (let i = 0; i < this.__PointGroups.length; i++)
    {
      let Points = this.__PointGroups[i]
      if (!Points.CanHighlightSegment)
        continue
      let PreviousPoint = Points.__Points[0]      
      for (let j = 0; j < Points.__Points.length; j++)
      {
        let SinglePoint = Points.__Points[j]

        let XPrevious = this.__GetXPixelsFromRealUdm(PreviousPoint.X);
        
        let XPoint    = this.__GetXPixelsFromRealUdm(SinglePoint.X)
        let YPoint    = this.__GetYPixelsFromRealUdm(SinglePoint.Y)

        if (SinglePoint.Id == PreviousPoint.Id &&
            (YPoint <= YCoord + 1 && 
             YPoint >= YCoord - 1) && 
             XCoord <= XPrevious && 
             XCoord >= XPoint)
        {
          LastMarkup = {}
          LastMarkup.Hint = SinglePoint.Hint
          LastMarkup.Coords = {}
          LastMarkup.Coords.X = XPoint
          LastMarkup.Coords.Y = YPoint
          break
        }
        PreviousPoint = SinglePoint
      }
    }
    return LastMarkup
  }

  ShowHorizontalAxisHint(XCoord, YCoord)
  {   
    let LastMarkup = null
    for (let i = 0; i < this.OtherAxis.length; i++)
    {
      let Axis = this.OtherAxis[i] 
      let YCoordAxis = this.__GetYPixelsFromRealUdm(Axis.DistanceFromX)
      let MinX = this.__GetXPixelsFromRealUdm(this.AxisX.Min)
      let MaxX = this.__GetXPixelsFromRealUdm(this.AxisX.Max)
      if ((YCoord <= YCoordAxis + 1 && YCoord >= YCoordAxis - 1) &&
          (XCoord >= MinX && XCoord <= MaxX))
      {
        LastMarkup = {}
        LastMarkup.Hint = {}
        LastMarkup.Hint.Dept = Axis.DistanceFromX
        LastMarkup.Coords = {}
        LastMarkup.Coords.X = XCoord
        LastMarkup.Coords.Y = YCoord 
        break
      }
    }
    return LastMarkup
  }

  __DrawRighelli()
  {
    for (let i = 0; i < this.ListaRighelli.length; i++)
    {
      let Righello = this.ListaRighelli[i]

      let ZeroY  = this.AxisY.Min
      let ZeroX  = this.AxisX.Min
      
      let Radius = null
      let CoordX = null
      let CoordY = null
      
      if(Righello.DistanceFromX)
        ZeroY = Righello.DistanceFromX
      if(Righello.DistanceFromY)
        ZeroX = Righello.DistanceFromY

      if(Righello.Inclination != null)
      {
        Radius = this.AxisX.Max - ZeroX
        CoordX = ZeroX + Radius * Math.cos(TZMathFunct.DegToRad(Axis.Inclination))
        CoordY = ZeroY + Radius * Math.sin(TZMathFunct.DegToRad(Axis.Inclination))      
      }
      else
      {
        if(this.ParalleloAsseX)
        {
          Radius = this.AxisX.Max - ZeroX
          CoordX = ZeroX + Radius * Math.cos(TZMathFunct.DegToRad(0))
          CoordY = ZeroY + Radius * Math.sin(TZMathFunct.DegToRad(0))
        }
        else
        {
          Radius = this.AxisX.Max - ZeroX
          CoordX = ZeroX + Radius * Math.cos(TZMathFunct.DegToRad(90))
          CoordY = ZeroY + Radius * Math.sin(TZMathFunct.DegToRad(90)) 
        }
      }

      if (CoordY > this.AxisY.Max)
        CoordY = this.AxisY.Max

      let MinX = this.__GetXPixelsFromRealUdm(ZeroX)
      let MinY = this.__GetYPixelsFromRealUdm(ZeroY)      
      let MaxX = this.__GetXPixelsFromRealUdm((CoordX))      
      let MaxY = this.__GetYPixelsFromRealUdm((CoordY))

      this.__Context.beginPath()
      this.__Context.lineWidth   = Righello.PenWidth
      this.__Context.strokeStyle = Righello.Color
      this.__Context.setLineDash(Righello.PenStyle)

      this.__Context.moveTo(MinX, MinY)
      this.__Context.lineTo(MaxX, MaxY)    
      this.__Context.stroke()
    }
  }
  
  Paint()
  {
    this.__CalculateMargins()
    let MinX = this.__GetXPixelsFromRealUdm(this.AxisX.Min)
    let MinY = this.__GetYPixelsFromRealUdm(this.AxisY.Min)
    let MaxX = this.__GetXPixelsFromRealUdm(this.AxisX.Max)
    let MaxY = this.__GetYPixelsFromRealUdm(this.AxisY.Max)

    let MinRealX = this.AxisX.Min
    let MaxRealX = this.AxisX.Max
    let MinRealY = this.AxisY.Min
    let MaxRealY = this.AxisY.Max

    if (this.AxisY.Inverted)
    {
      MinRealY = this.AxisY.Max
      MaxRealY = this.AxisY.Min
    }
    
    this.__Context.clearRect(0, 0, this.__Canvas.width, this.__Canvas.height)
    this.__Context.fillStyle = this.Background
    this.__Context.fillRect(0, 0, this.__Canvas.width, this.__Canvas.height)
    this.__Context.fillStyle = 'transparent'
    this.__DrawXNotches(MinY, MaxY)

    if (this.AxisX.NotchType != TZGraphNotchType.notPolar)
      this.__DrawYNotches(MinX, MaxX)


    if (MinRealY <= 0 && MaxRealY >= 0)
      this.__DrawXAxis(MinX, MaxX)    
    if (MinRealX <= 0 && MaxRealX >= 0)
      this.__DrawYAxis(MinY, MaxY)
    if (this.OtherAxis.length > 0)
    {
      if (this.AxisX.NotchType == TZGraphNotchType.notPolar)
        this.__DrawOtherAxisPolar()
      else 
      {
        if(!this.MultipleDrawingAxis)
        {
          if(this.OtherAxis.length != 0)
            if(this.OtherAxis[0] != null)
            {              
              this.__DrawYRightNotches(this.OtherAxis[0])
              this.__DrawRightSideLabels(this.OtherAxis[0])
            }
        }
        else this.GestioneMultipleDrawingAxis()
      }
    }
    //DISEGNA I BORDI
    if (this.DrawBorders)
    {
      if(!this.MultipleDrawingAxis)
      {
        this.__Context.beginPath()
        this.__Context.strokeStyle = this.AxisX.Color
        this.__Context.setLineDash(this.AxisX.PenStyle)
        this.__Context.moveTo(this.__Margins.Left, this.__Margins.Top) //Partenza in alto a sinistra
        this.__Context.lineTo(this.__Canvas.width - this.__Margins.Right, this.__Margins.Top) //sinistra verso destra
        this.__Context.lineTo(this.__Canvas.width - this.__Margins.Right, this.__Canvas.height - this.__Margins.Bottom) //destra verso il basso destra
        this.__Context.lineTo(this.__Margins.Left, this.__Canvas.height - this.__Margins.Bottom) // destra verso sinistra
        this.__Context.lineTo(this.__Margins.Left, this.__Margins.Top) //sinistra in basso verso sinistra in alto (asse Y)
        this.__Context.stroke()
      }
      else
      {
        this.__Context.beginPath()
        this.__Context.strokeStyle = this.AxisX.Color
        this.__Context.setLineDash(this.AxisX.PenStyle)
        this.__Context.moveTo(this.__Margins.Left, this.__Margins.Top) //Partenza in alto a sinistra
        this.__Context.lineTo(this.__Canvas.width - this.__Margins.Right, this.__Margins.Top) //sinistra verso destra
        this.__Context.lineTo(this.__Canvas.width - this.__Margins.Right, this.__Canvas.height - this.__Margins.Bottom) //destra verso il basso destra
        this.__Context.lineTo(this.__Margins.Left, this.__Canvas.height - this.__Margins.Bottom) // destra verso sinistra
        this.__Context.stroke()
        
        this.__Context.beginPath()
        this.__Context.strokeStyle = this.AxisY.Color
        this.__Context.setLineDash(this.AxisX.PenStyle)
        this.__Context.moveTo(this.__Margins.Left, this.__Canvas.height - this.__Margins.Bottom)
        this.__Context.lineTo(this.__Margins.Left, this.__Margins.Top) //sinistra in basso verso sinistra in alto (asse Y)
        this.__Context.stroke()
      }
    }

    if(this.DeleteGraphOverboard)
    {
      this.__Context.fillStyle = this.Background
      this.__Context.fillRect(this.__Margins.Left, this.__Margins.Top, this.__Canvas.width - this.__Margins.Right, - 100)
      this.__Context.fillRect(this.__Canvas.width - this.__Margins.Right, this.__Margins.Top, 100,  this.__Canvas.height - this.__Margins.Bottom)
      this.__Context.fillRect(this.__Margins.Left, this.__Canvas.height - this.__Margins.Bottom, this.__Canvas.height - this.__Margins.Bottom, 100)
      this.__Context.fillRect(this.__Margins.Left, this.__Margins.Top, -100, this.__Canvas.height - this.__Margins.Bottom)
      this.__Context.fillStyle = 'transparent'
    }

    if (this.AxisY.DrawLabels)
      this.__DrawLeftSideLabels()
    if (this.AxisX.DrawLabels)
      this.__DrawBottomSideLabels()
    if (this.AxisX.DrawUpperLabel)
      this.__DrawUpperLabel()
    if(this.CenterLabel != '')
      this.__DrawCenterLabel()

    if(this.AxisX.CenterLabel != '' && this.AxisX.CenterLabel != null)
      this.__DrawCenterLabelX()
    
    if(this.ListaRighelli.length != 0)
      this.__DrawRighelli()
  }

  GestioneMultipleDrawingAxis()
  {
    if(this.OtherAxis.length != 0)
    {
      let i = 0
      let Self = this

      this.OtherAxis.forEach(function(Asse)
      {
        Self.__DrawYRightNotchesMultipleAxes(Asse, i)
        Self.__DrawYRightSideLabelsMultipleAxes(Asse, i)
        Self.__DrawYLinesRightAxes(Asse, i)
        i++;
      })
    }
  }
}

export class TZGraphMarkup extends TZGraph
{
  constructor(Canvas)
  {
    super(Canvas)
    this.DrawMarkup = true
    this.ListaSegmenti = []
  }

  AddSegmento(StartPointX, StartPointY, EndPointX, EndPointY, Label, Soglia = false)
  {
    let StartPoint = new TSimplePoint(StartPointX, StartPointY)
    let EndPoint   = new TSimplePoint(EndPointX, EndPointY)
    this.ListaSegmenti.push(new TSegmento(StartPoint, EndPoint, Label, Soglia))
  }

  ClearSegmenti()
  {
    this.ListaSegmenti = []
  }
  
  HighlightMarkup(XCoord, YCoord)
  {
    let LastMarkup = null
    let PuntiFuoriDalGrafico = false
    
    if( XCoord <= (this.__Margins.Left) || 
        XCoord >= (this.__Canvas.width - this.__Margins.Right) ||
        YCoord <= (this.__Margins.Top) || 
        YCoord >= (this.__Canvas.height - this.__Margins.Bottom))
      PuntiFuoriDalGrafico = true

    if(!PuntiFuoriDalGrafico)
    {
      for (let i = 0; i < this.__PointGroups.length; i++)
      {
        let AxisYInUse = this.__PointGroups[i].__AlternativeAxisY
        let Trovato = false
        let Points = this.__PointGroups[i]
        for (let j = 0; j < Points.__Points.length; j++)
        {
          let SinglePoint = Points.__Points[j]
          if (SinglePoint.DrawMarkup && SinglePoint.Y != null)
          {
            let XPoint = this.__GetXPixelsFromRealUdm(SinglePoint.X)
            let YPoint = this.__GetYPixelsFromRealUdm(SinglePoint.Y, AxisYInUse)
            if (XPoint - this.MarkupWidth / 2 <= XCoord && XPoint + this.MarkupWidth / 2 >= XCoord &&
                YPoint - this.MarkupWidth / 2 <= YCoord && YPoint + this.MarkupWidth / 2 >= YCoord &&
                (SinglePoint != Points.__Points[0] || this.ShowFirstMarkup))
            {
              Trovato = true
              if (Points.LastMarkup != SinglePoint)
              {            
                if (Points.LastMarkup != null)
                {
                  this.Paint(false)
                  // this.__DrawSingleMarkup(Points.LastMarkup, Points.__Markup, Points.__MarkupHighlighted, false)
                } 
                this.__DrawSingleMarkup(SinglePoint, Points.__Markup, Points.__MarkupHighlighted, true, AxisYInUse)
                Points.LastMarkup = SinglePoint            
              }
              LastMarkup = Points.LastMarkup
              LastMarkup.Coords = {}
              LastMarkup.Coords.X = XPoint
              LastMarkup.Coords.Y = YPoint 
              break
            }
          }        
        }
        if (!Trovato && Points.LastMarkup != null)
        {
          // this.__DrawSingleMarkup(Points.LastMarkup, Points.__Markup, Points.__MarkupHighlighted, false)
          this.Paint(false)
          Points.LastMarkup = null
        }
        if(Trovato) 
          break
      }
    }

    return LastMarkup
  }  

  HighlightMarkupByIdAndDate(MarkupModule, MarkupDate)
  {
    let Point = undefined
    for (let i = 0; i < this.__PointGroups.length; i++)
    {
      let Points = this.__PointGroups[i]
      Point = Points.__Points.find((element) => {return element.Hint.Data == MarkupDate && element.Hint.Modulo == MarkupModule})
      if (Point != undefined)
        break
    }
    this.HighlightMarkup(this.__GetXPixelsFromRealUdm(Point.X), this.__GetYPixelsFromRealUdm(Point.Y))
  }

  FGetDrawMarkupPointGroup()
  {
    for (let i = 0; i < this.__PointGroups.length; i++)
      if (this.__PointGroups[i].DrawMarkup)
        return true
    return false
  }

  Paint(DrawAll = true)
  {
    if (DrawAll)
      super.Paint()
    let MinRealX = this.AxisX.Min
    let MaxRealX = this.AxisX.Max
    
    if (this.DrawMarkup || this.FGetDrawMarkupPointGroup())
    {
      for (let i = 0; i < this.__PointGroups.length; i++)
      {
        if (this.__PointGroups[i].Visible && this.__PointGroups[i].DrawMarkup)
        {
          let Points    = this.__PointGroups[i].__Points
          let Markup    = this.__PointGroups[i].__Markup
          
          let AxisYInUse = this.__PointGroups[i].__AlternativeAxisY == null ? this.AxisY : this.__PointGroups[i].__AlternativeAxisY
          
          if (Points.length >= 1)
          {     
            for (let i = 0; i < Points.length; i++)
            {
              let Point = Points[i]
              if (Point.Y == null)
                continue
              if (i != 0 || this.ShowFirstMarkup)
              {
                let MinRealY = AxisYInUse.Min
                let MaxRealY = AxisYInUse.Max
                
                if (AxisYInUse.Inverted)
                {
                  MinRealY = AxisYInUse.Max
                  MaxRealY = AxisYInUse.Min
                }
                if (Markup == null)
                  Markup = this.__Markup
                if (Point.DrawMarkup &&
                    Point.X >= MinRealX  && Point.X <= MaxRealX &&
                    Point.Y >= MinRealY && Point.Y <= MaxRealY)
                {
                  // this.__Context.drawImage(Markup, 
                  //                           this.__GetXPixelsFromRealUdm(StartPoint.X) - this.MarkupWidth / 2, 
                  //                           this.__GetYPixelsFromRealUdm(StartPoint.Y) - this.MarkupWidth / 2, 
                  //                           this.MarkupWidth, 
                  //                           this.MarkupWidth)
                  
                    // this.__Context.beginPath()
                    // this.__Context.fillStyle = Point.Color
                    // this.__Context.arc(this.__GetXPixelsFromRealUdm(Point.X),
                    //                    this.__GetYPixelsFromRealUdm(Point.Y),
                    //                    this.MarkupWidth / 2,
                    //                    0,
                    //                    2 * Math.PI)
                    // this.__Context.fill()

                  this.__DrawSingleMarkup(Point, Points.__Markup, null, false, AxisYInUse)
                }
              }            
            }
          }
        }
      }
    } 

    for (let i = 0; i < this.ListaSegmenti.length; i++)
    {
      let Segmento   = this.ListaSegmenti[i]
      let AxisYInUse = Segmento.AsseDiRiferimento == null ? this.AxisY : Segmento.AsseDiRiferimento

      this.__Context.beginPath()
      this.__Context.strokeStyle = Segmento.Color
      this.__Context.lineWidth = Segmento.PenWidth
      this.__Context.setLineDash(Segmento.PenStyle)

      this.__Context.moveTo(this.__GetXPixelsFromRealUdm(Segmento.StartPoint.X),   this.__GetYPixelsFromRealUdm(Segmento.StartPoint.Y, AxisYInUse))
      this.__Context.lineTo(this.__GetXPixelsFromRealUdm(Segmento.EndPoint.X), this.__GetYPixelsFromRealUdm(Segmento.EndPoint.Y, AxisYInUse))
      
      this.__Context.stroke()
      if (Segmento.Label != '')
      {
        this.__Context.fillStyle = Segmento.Color
        let LunghezzaSegmentoX = this.__GetXPixelsFromRealUdm(Segmento.EndPoint.X) - this.__GetXPixelsFromRealUdm(Segmento.StartPoint.X)
        let XMedio = this.__GetXPixelsFromRealUdm(Segmento.StartPoint.X) + LunghezzaSegmentoX / 2
        let LunghezzaSegmentoY = this.__GetYPixelsFromRealUdm(Segmento.EndPoint.Y, AxisYInUse) - this.__GetYPixelsFromRealUdm(Segmento.StartPoint.Y, AxisYInUse)
        let YMedio = this.__GetYPixelsFromRealUdm(Segmento.StartPoint.Y, AxisYInUse) + LunghezzaSegmentoY / 2
        this.__Context.fillText(Segmento.Label,XMedio,YMedio - 10)
      }
    }
  }  
}

export class TZGraphLine extends TZGraphMarkup
{
  constructor(Canvas)
  {
    super(Canvas);
    this.LineToMinY = false;
    this.ResetToZero = false;
  }

  AggiustaPuntiSegmenti()
  {
    for (let i = 0; i < this.ListaSegmenti.length; i++)
    {
      let Segmento = this.ListaSegmenti[i]
      
      if (Segmento.StartPoint.Y == undefined || Segmento.EndPoint.Y == undefined)
      {
        let GruppoPunti = this.__PointGroups[0];
        
        if (GruppoPunti.__Points.length >= 2)
        {
          let StartPoint = GruppoPunti.__Points[0]
          
          for (let j = 1; j < GruppoPunti.__Points.length; j++)
          {
            let CurrentPoint = GruppoPunti.__Points[j]
            let m = (CurrentPoint.Y - StartPoint.Y) / (CurrentPoint.X - StartPoint.X)
            let q = StartPoint.Y - m * StartPoint.X
            
            if (Segmento.StartPoint.X <= CurrentPoint.X && Segmento.StartPoint.Y == undefined)
            {
              Segmento.StartPoint.Y = m * Segmento.StartPoint.X + q
            }
            
            if (Segmento.EndPoint.X <= CurrentPoint.X)
            {
              Segmento.EndPoint.Y = m * Segmento.EndPoint.X + q
            }
            
            if (Segmento.StartPoint.Y != undefined && Segmento.EndPoint.Y != undefined)
              break
            StartPoint = CurrentPoint
          }
        }
      }
    }
  }
  
  Paint()
  {
    this.AggiustaPuntiSegmenti()
    super.Paint()
    
    for (let i = 0; i < this.__PointGroups.length; i++)
    {
      let TipoPuntiGrafico = this.__PointGroups[i].Tipologia 

      if (this.__PointGroups[i].Visible)
      {
        let Points     = this.__PointGroups[i].__Points
        let Color      = this.__PointGroups[i].Color
        let PenWidth   = this.__PointGroups[i].PenWidth
        let AxisYInUse = this.__PointGroups[i].__AlternativeAxisY == null ? this.AxisY : this.__PointGroups[i].__AlternativeAxisY
        // let Markup = this.__PointGroups[i].__Markup

        switch(TipoPuntiGrafico)
        {
          case TZTipologiaPointGroups.Histogram : let PointWidth = this.__PointGroups[i].PointWidth != null? 
                                                                   this.__PointGroups[i].PointWidth : 
                                                                   this.AxisX.NotchDim

                                                  for (let i = 0; i < Points.length; i++)
                                                  {
                                                    let MinY = AxisYInUse.Min
                                                    let MaxY = AxisYInUse.Max 
                                                    let TempPointWidth = 0
                                                    
                                                    if (this.AxisY.Inverted)
                                                    {
                                                      MinY = AxisYInUse.Max
                                                      MaxY = AxisYInUse.Min
                                                    }
                                                    let Point = {X: Points[i].X, Y: Points[i].Y}
                                                    this.__Context.fillStyle = Color

                                                    if(Point.X + PointWidth > this.AxisX.Max)  
                                                    {
                                                      TempPointWidth = PointWidth                     
                                                      PointWidth = this.AxisX.Max - Point.X 
                                                    }                   
                                                    
                                                    if(Point.X < this.AxisX.Min)
                                                    {                  
                                                      TempPointWidth = PointWidth                     
                                                      PointWidth = PointWidth - (this.AxisX.Min - Point.X)
                                                      Point.X = this.AxisX.Min
                                                    }

                                                    if(Point.X + PointWidth >= this.AxisX.Min && Point.X <= this.AxisX.Max)
                                                      this.__Context.fillRect(this.__GetXPixelsFromRealUdm(Point.X),
                                                                              this.__GetYPixelsFromRealUdm(MinY, AxisYInUse),
                                                                              this.__GetXPixelsFromRealUdm(Point.X + PointWidth) - this.__GetXPixelsFromRealUdm(Point.X),
                                                                              this.__GetYPixelsFromRealUdm(Point.Y + MinY, AxisYInUse) - this.__GetYPixelsFromRealUdm(MinY, AxisYInUse))    
                                                                              
                                                    if(TempPointWidth != 0)
                                                      PointWidth = TempPointWidth

                                                  }
                                                  break;
          default                              :  if (Points.length >= 2)
                                                  {
                                                    let StartPoint = Points[0]

                                                    let MinX = this.AxisX.Min
                                                    let MaxX = this.AxisX.Max
                                                    let MinY = AxisYInUse.Min
                                                    let MaxY = AxisYInUse.Max 

                                                    let DrawLineFromStartToCurrent = (Start, Current) =>
                                                    {
                                                      let VLine = false
                                                      let m = (Current.Y - Start.Y) / (Current.X - Start.X)
                                                      let q = Start.Y - m * Start.X
                                                      
                                                      if (this.AxisY.Inverted)
                                                      {
                                                        MinY = AxisYInUse.Max
                                                        MaxY = AxisYInUse.Min
                                                      }
                                                      
                                                      if (Start.X == Current.X)
                                                        VLine = true
                                                      
                                                      this.__Context.beginPath()
                                                      this.__Context.strokeStyle = Color
                                                      this.__Context.lineWidth = PenWidth
                                                      this.__Context.setLineDash(StartPoint.Style)
                                                      if (!(((Current.Y > MaxY) && (Start.Y > MaxY)) ||
                                                            ((Current.Y < MinY) && (Start.Y < MinY)) ||
                                                            ((Current.X > MaxX) && (Start.X > MaxX)) ||
                                                            ((Current.X < MinX) && (Start.X < MinX))))
                                                      {
                                                        if (Start.X > MaxX || Start.X < MinX)
                                                        {
                                                          if (Start.X > MaxX)
                                                            Start.X = MaxX
                                                          else 
                                                            Start.X = MinX;
                                                          Start.Y = m * Start.X + q;
                                                        }
                                                        if (Current.X > MaxX || Current.X < MinX)
                                                        {
                                                          if (Current.X > MaxX)
                                                            Current.X = MaxX
                                                          else 
                                                            Current.X = MinX;
                                                          Current.Y = m * Current.X + q;
                                                        }
                                                        if (Start.Y > MaxY || Start.Y < MinY)
                                                        {
                                                          if (Start.Y > MaxY)
                                                            Start.Y = MaxY
                                                          else 
                                                            Start.Y = MinY;
                                                          if (!VLine)
                                                            Start.X = (Start.Y - q) / m
                                                        }
                                                        if (Current.Y > MaxY || Current.Y < MinY)
                                                        {
                                                          if (Current.Y > MaxY)
                                                            Current.Y = MaxY
                                                          else 
                                                            Current.Y = MinY;
                                                          if (!VLine)
                                                            Current.X = (Current.Y - q) / m
                                                        }
                                                        
                                                        this.__Context.moveTo(this.__GetXPixelsFromRealUdm(Start.X),   this.__GetYPixelsFromRealUdm(Start.Y, AxisYInUse))
                                                        this.__Context.lineTo(this.__GetXPixelsFromRealUdm(Current.X), this.__GetYPixelsFromRealUdm(Current.Y, AxisYInUse))

                                                        this.__Context.stroke()
                                                      }
                                                    }
                                                    
                                                    if(this.LineToMinY)
                                                    {
                                                      let Start = {X: 0, Y: MinY}
                                                      let Current = {X: StartPoint.X, Y: StartPoint.Y}
                                                      if (StartPoint.DrawLine)
                                                        DrawLineFromStartToCurrent(Start, Current)
                                                    }

                                                    for (let i = 1; i < Points.length; i++)
                                                    {
                                                      if (Points[i].Y == null)
                                                      {
                                                        StartPoint = Points[i]
                                                        continue
                                                      }
                                                      let Start = { X: StartPoint.X, Y: StartPoint.Y }
                                                      let Current = { X: Points[i].X, Y: Points[i].Y }    
                                                      
                                                      if(!this.ResetToZero)
                                                      {
                                                        if (StartPoint.DrawLine)
                                                          DrawLineFromStartToCurrent(Start, Current)
                                                      }              
                                                      else
                                                      {
                                                        if((Current.Y != 0 || (Current.Y == 0 && Start.Y == 0)) && StartPoint.DrawLine)
                                                          DrawLineFromStartToCurrent(Start, Current)
                                                      }                                    
                                                      
                                                      StartPoint = Points[i]
                                                    }
                                                  }
                                                  break;
        }
      }
    }
  }
}

export class TZGraphHistogram extends TZGraph
{
  constructor(Canvas)
  {
    super(Canvas)
    this.PointWidth = this.AxisX.NotchDim
  }
  
  Paint()
  {
    super.Paint()
    for (let i = 0; i < this.__PointGroups.length; i++)
    {
      if (this.__PointGroups[i].Visible)
      {
        let Points   = this.__PointGroups[i].__Points
        let Color    = this.__PointGroups[i].Color
        for (let i = 0; i < Points.length; i++)
        {          
          let MinY = this.AxisY.Min
          let MaxY = this.AxisY.Max
          
          if (this.AxisY.Inverted)
          {
            MinY = this.AxisY.Max
            MaxY = this.AxisY.Min
          }
          let Point = {X: Points[i].X, Y: Points[i].Y}
          this.__Context.fillStyle = Color
          this.__Context.fillRect(this.__GetXPixelsFromRealUdm(Point.X),
                                  this.__GetYPixelsFromRealUdm(MinY),
                                  this.__GetXPixelsFromRealUdm(Point.X + this.PointWidth) - this.__GetXPixelsFromRealUdm(Point.X),
                                  this.__GetYPixelsFromRealUdm(Point.Y + MinY) - this.__GetYPixelsFromRealUdm(MinY))     
        }
      }
    }
    
    if(this.ListaRighelli.length != 0)
      this.__DrawRighelli()
  }
}

export class TZGraphVertHistogram extends TZGraph
{
  constructor(Canvas)
  {
    super(Canvas)
    this.PointWidth = this.AxisY.NotchDim
  }
  
  Paint()
  {
    super.Paint()
    for (let i = 0; i < this.__PointGroups.length; i++)
    {
      if (this.__PointGroups[i].Visible)
      {
        let Points   = this.__PointGroups[i].__Points
        let Color    = this.__PointGroups[i].Color
        for (let i = 0; i < Points.length; i++)
        {          
          let MinX = this.AxisX.Min
          let MaxX = this.AxisX.Max
          
          // if (this.AxisY.Inverted)
          // {
          //   MinY = this.AxisY.Max
          //   MaxY = this.AxisY.Min
          // }
          let Point = {X: Points[i].X, Y: Points[i].Y}
          this.__Context.fillStyle = Color

          this.__Context.fillRect(this.__GetXPixelsFromRealUdm(MinX),
                                  this.__GetYPixelsFromRealUdm(Point.Y),
                                  this.__GetXPixelsFromRealUdm(Point.X + MinX) - this.__GetXPixelsFromRealUdm(MinX),
                                  this.__GetYPixelsFromRealUdm(Point.Y + this.PointWidth) - this.__GetYPixelsFromRealUdm(Point.Y))     
        }
      }
    }
  }
}

export class TRighello
{
  constructor()
  {  
    this.Color          = "black"
    this.PenStyle       = []
    this.PenWidth       = 1
    this.Inclination    = null
    this.ParalleloAsseX = false
    this.DistanceFromY  = null
    this.DistanceFromX  = null
  }
}

export class TSegmento 
{
  constructor(StartPoint, EndPoint, Label, Soglia)
  {
    this.Color             = "red"
    this.PenStyle          = []
    this.PenWidth          = 2
    this.StartPoint        = StartPoint
    this.EndPoint          = EndPoint
    this.Label             = Label
    this.AsseDiRiferimento = null
    this.Soglia            = Soglia
  }
}